import { findDOMNode } from 'react-dom';
import { isElement } from '@flowio/browser-helpers';
export default function findDOMElement(instance) {
  // eslint-disable-next-line react/no-find-dom-node
  var node = findDOMNode(instance);
  return isElement(node) ? node : null;
}